export default __webpack_public_path__ + "static/media/slo.84e12733.svg";